import client, { profitQuery, unwrap } from './client';

/** params: { range, customDays, month?, dataMode } */
export const getAnalytics = (params) =>
  client
    .get(
      `/profit-pulse/analytics${profitQuery({
        range: params.range,
        customDays: params.customDays,
        month: params.month,
        dataMode: params.dataMode,
      })}`
    )
    .then(unwrap);

/**
 * One page of the menu list. The window fields are the same `/analytics` takes,
 * because the cards are priced against that window's dashboard.
 *
 * `sort` and `order` have to be stated: the endpoint ranks by profit for a
 * caller that says nothing, while the dashboard's own first page is ranked by
 * revenue, and the list is painted out of both.
 *
 * params: { range, customDays, month?, dataMode, page?, limit?, sort?, order?,
 * search?, category? }
 */
export const getMenuItems = (params) =>
  client
    .get(
      `/profit-pulse/menu-items${profitQuery({
        range: params.range,
        customDays: params.customDays,
        month: params.month,
        dataMode: params.dataMode,
        page: params.page,
        limit: params.limit,
        sort: params.sort,
        order: params.order,
        search: params.search,
        category: params.category,
      })}`
    )
    .then(unwrap);

// The mode decides whether the cost is stored against the MMS product id or
// the item's name, so it travels with the write as well as the read.
export const updateMenuItem = (productId, body, dataMode) =>
  client
    .patch(
      `/profit-pulse/menu-items/${productId}${profitQuery({ dataMode })}`,
      body
    )
    .then(unwrap);
